import {Card,CardBody,CardHeader} from 'reactstrap';
import { Alert,AlertTitle,Typography } from '@mui/material';
import { List,ListItemButton,ListItemIcon,ListItemText } from '@mui/material';
import { ImageList,ImageListItem } from '@mui/material';
import {BiRightArrow} from 'react-icons/bi'
import paproy from './Recursos/Proceso_aprobacion_proyectos2019.png'
import paprop from './Recursos/Proceso_aprobacion_propuestas2019.png'

export default function Home (){
    return(
    <Card>
        <CardHeader>Introducción</CardHeader>
        <CardBody>
          <Alert severity="info">
           <AlertTitle>Info</AlertTitle>
            Estimado Investigador, se le recuerda que el OrcID que debe estar registrado en le sistema de Investigación debe tener estar formado por 4 segmentos de 4 digitos cada uno, separados por guiones(-). No tiene que ingresar<strong>Url</strong> Ejemplo: <strong>0000-0000-0000-0000</strong>
          </Alert>
          <br />
          <Typography paragraph>
           La plataforma de <strong>Gestión de Proyectos</strong>, es un sistema que permite realizar un control a los proyectos y propuestas de investigación que se ejecuntan en ESPOL.
          </Typography>
          <Typography><strong>Instrucciones</strong></Typography>
            <List sx={{bgcolor: 'background.paper' }}>
      <ListItemButton>
        <ListItemIcon>
          <BiRightArrow />
        </ListItemIcon>
        <ListItemText primary="En la sección 'Proyectos/Propuestas' debe ingresar todos los datos requeridos para que el proyecto de investigación sea autorizado." />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <BiRightArrow />
        </ListItemIcon>
        <ListItemText primary="El sistema le notificará cualquier novedad en base a su proyecto." />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <BiRightArrow />
        </ListItemIcon>
        <ListItemText primary="No olvidarse que a medida que vaya obteniendo resultados deben ser ingresados al sistema para ser contabilizados." />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <BiRightArrow />
        </ListItemIcon>
        <ListItemText primary="Para fines de Evaluación Integral Docente, las propuestas de investigación del año 2023 deberán ser ingresadas en la plataforma de Investigación." />
      </ListItemButton>
      <ListItemButton>
        <ListItemIcon>
          <BiRightArrow />
        </ListItemIcon>
        <ListItemText primary="Las propuestas de financiamiento de investigación tienen que ser aprobadas por el Coordinador de la Unidad Académica o del Centro de Investigación al que pertenezca." />
      </ListItemButton>
    </List>
    <ImageList >
      <ImageListItem key='proy'>
       <img
        src={paproy}
        srcSet={paproy}
        alt={'proyecto'}
        loading="lazy"
       />
      </ImageListItem>
    </ImageList>
    <ImageList >
      <ImageListItem key='proy'>
       <img
        src={paprop}
        srcSet={paprop}
        alt={'proyecto'}
        loading="lazy"
       />
      </ImageListItem>
    </ImageList>
        </CardBody>
    </Card>
    )
}